import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectPermissionState = (state: AppState) =>
  state.permission;


export const selectPermittedCommands = createSelector(
  selectPermissionState,
  (state) => state.permittedCommands
);
export const selectPermissionsLoading= createSelector(
  selectPermissionState,
  (state) => state.loading
);
export const selectPermissions= createSelector(
  selectPermissionState,
  (state) => state.permissions
);
export const selectPermissionsPaging= createSelector(
  selectPermissionState,
  (state) => state.paging
);
export const selectPermissionsAdded= createSelector(
  selectPermissionState,
  (state) => state.added
);
export const selectPermissionsAdding= createSelector(
  selectPermissionState,
  (state) => state.adding
);
export const selectPermissionsEdited= createSelector(
  selectPermissionState,
  (state) => state.edited
);
export const selectPermissionsEditing= createSelector(
  selectPermissionState,
  (state) => state.editing
);
export const selectPermissionsDeleted= createSelector(
  selectPermissionState,
  (state) => state.deleted
);
export const selectPermissionsPinResetted= createSelector(
  selectPermissionState,
  (state) => state.pinResetted
);
export const selectPermission= createSelector(
  selectPermissionState,
  (state) => state.permission
);
export const selectLoadingTemplates= createSelector(
  selectPermissionState,
  (state) => state.loadingTemplates
);
export const selectCurrentTemplate = createSelector(
  selectPermissionState,
  (state) => state.currentTemplate
);
export const selectTemplateUpdated = createSelector(
  selectPermissionState,
  (state) => state.templateUpdated
);
export const selectTemplateUpdating = createSelector(
  selectPermissionState,
  (state) => state.templateUpdating
);
export const selectTemplateLogo = createSelector(
  selectPermissionState,
  (state) => state.templateLogo
);
export const selectExceptions = createSelector(
  selectPermissionState,
  (state) => state.exceptions
);
export const selectPermissionsCalendar = createSelector(
  selectPermissionState,
  (state) => state.permissionsCalendar
);
export const selectValidToken = createSelector(
  selectPermissionState,
  (state) => state.validToken
);
export const selectPinSetting = createSelector(
  selectPermissionState,
  (state) => state.pinSetting
);
export const selectValidPin= createSelector(
  selectPermissionState,
  (state) => state.validPin
);
export const selectCommandExecutionError = createSelector(
  selectPermissionState,
  (state) => state.commandExecutionError
);
export const selectCommandExecutionErrorId = createSelector(
  selectPermissionState,
  (state) => state.commandExecutionErrorId
);
export const selectShowPinPad = createSelector(
  selectPermissionState,
  (state) => state.showPinPad
);
